import { ChevronRight, type LucideIcon } from "lucide-react";

import { cn } from "@/lib/utils";

/**
 * SectionHeader — the feed rail/section title row (mockup: Kraahl Desktop Home).
 * A Lucide glyph + bold title, with an optional muted "See all" affordance
 * (→ foreground on hover). Presentational; the caller wires `onSeeAll`.
 */
export function SectionHeader({
  icon: Icon,
  title,
  seeAllLabel = "See all",
  onSeeAll,
  className,
}: {
  icon: LucideIcon;
  title: string;
  seeAllLabel?: string;
  onSeeAll?: () => void;
  className?: string;
}) {
  return (
    <div
      className={cn(
        "mb-4 flex items-center justify-between gap-3 border-b border-border/60 pb-2.5",
        className,
      )}
    >
      <div className="flex items-center gap-2.5">
        <Icon className="size-5 shrink-0 text-foreground" strokeWidth={2} />
        <h2 className="text-lg font-bold tracking-tight">{title}</h2>
      </div>
      {onSeeAll ? (
        <button
          type="button"
          onClick={onSeeAll}
          className="flex items-center gap-1 text-sm font-semibold text-muted-foreground transition-colors hover:text-foreground"
        >
          {seeAllLabel}
          <ChevronRight className="size-4" />
        </button>
      ) : null}
    </div>
  );
}
